import { cn } from "@/shared/lib/utils";

const LOGO_SRC = "/logo.svg";

export function BrandMark({ size = 32, className }: { size?: number; className?: string }) {
  const mask = {
    maskImage: `url(${LOGO_SRC})`,
    maskRepeat: "no-repeat",
    maskSize: "contain",
    maskPosition: "center",
  };
  return (
    <span
      aria-hidden
      className={cn("block shrink-0", className)}
      style={{
        width: Math.round((size * 351) / 676),
        height: size,
        color: "var(--ds-brand-mark)",
        backgroundColor: "currentColor",
        ...mask,
        WebkitMaskImage: mask.maskImage,
        WebkitMaskRepeat: mask.maskRepeat,
        WebkitMaskSize: mask.maskSize,
        WebkitMaskPosition: mask.maskPosition,
      }}
    />
  );
}

export function Wordmark({
  size = 32,
  nameSize = 20,
  className,
}: {
  size?: number;
  nameSize?: number;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <BrandMark size={size} />
      <span
        style={{
          fontFamily: "var(--ds-font-display)",
          fontWeight: 800,
          fontSize: nameSize,
          letterSpacing: "-0.02em",
          color: "hsl(var(--ds-text-heading))",
        }}
      >
        Integri<span style={{ letterSpacing: "-0.06em" }}>t</span>ty
      </span>
    </div>
  );
}
